import { FC, useState } from "react";
import CustomButton from "ui/Button";
import { ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import CustomDropDownList from "ui/dropDown";
import { UserListFilter } from "api/user";
import { Input } from "@progress/kendo-react-inputs";
import { UserListDynamicColumns } from "./UserListGridColumns";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: UserListFilter) => void;
	filterOptions: UserListFilter;
	roles: any[];
	exportAsPDF: () => void;
	exportAsExcel: () => void;
	setDynamicColumns: React.Dispatch<
		React.SetStateAction<UserListDynamicColumns>
	>;
}

const columnFieldMap: Partial<
	Record<keyof UserListFilter, keyof UserListDynamicColumns>
> = {
	buyer: "buyers",
	terminal: "terminals",
	vessel: "vessels",
};

const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	roles,
	setDynamicColumns,
	...props
}) => {
	const { t } = useTranslation();
	const [filter, setFilter] = useState<UserListFilter>();

	const applyFilter = (field: keyof UserListFilter) => {
		const trimmedValue = (filter?.[field] || "").toString().trim();
		const currentValue = (filterOptions[field] || "").toString().trim();
		if (trimmedValue === currentValue) {
			return;
		}
		setFilterOptions({
			...filterOptions,
			[field]: trimmedValue,
			skip: 0,
		});

		const columnKey = columnFieldMap[field];
		if (columnKey && trimmedValue !== "") {
			setDynamicColumns((prev) => ({
				...prev,
				[columnKey]: {
					...prev[columnKey],
					hidden: false,
				},
			}));
		}
	};
	return (
		<div className="filter-container">
			<div className="filter-items user-list-filter-items">
				<div style={{ width: "170px" }}>
					<Input
						placeholder={t("FirstName")}
						value={filter?.firstname || ""}
						label={t("FirstName")}
						autoComplete="off"
						onChange={(e) => {
							setFilter({ ...filter, firstname: e.value });
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter") applyFilter("firstname");
						}}
						onBlur={() => applyFilter("firstname")}
						style={{ width: "100%" }}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<Input
						placeholder={t("LastName")}
						value={filter?.lastname || ""}
						label={t("LastName")}
						autoComplete="off"
						onChange={(e) => {
							setFilter({ ...filter, lastname: e.value });
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter") applyFilter("lastname");
						}}
						onBlur={() => applyFilter("lastname")}
						style={{ width: "100%" }}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<Input
						placeholder={t("Email")}
						value={filter?.email || ""}
						label={t("Email")}
						autoComplete="off"
						onChange={(e) => {
							setFilter({ ...filter, email: e.value });
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter") applyFilter("email");
						}}
						onBlur={() => applyFilter("email")}
						style={{ width: "100%" }}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(role) => {
							setFilterOptions({
								...filterOptions,
								roleId: role.id,
								skip: 0,
							});
						}}
						data={roles}
						dataItemKey="id"
						textField="name"
						label={t("Roles")}
						defaultItem={{ id: null, name: `${t("Choose")} ${t("Roles")}` }}
						className="height-inherit"
					/>
				</div>
				<div style={{ width: "170px" }}>
					<Input
						placeholder={t("Buyer")}
						value={filter?.buyer || ""}
						label={t("Buyer")}
						autoComplete="off"
						onChange={(e) => {
							setFilter({ ...filter, buyer: e.value });
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter") applyFilter("buyer");
						}}
						onBlur={() => applyFilter("buyer")}
						style={{ width: "100%" }}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<Input
						placeholder={t("Terminal")}
						value={filter?.terminal || ""}
						label={t("Terminal")}
						autoComplete="off"
						onChange={(e) => {
							setFilter({ ...filter, terminal: e.value });
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter") applyFilter("terminal");
						}}
						onBlur={() => applyFilter("terminal")}
						style={{ width: "100%" }}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<Input
						placeholder={t("Vessel")}
						value={filter?.vessel || ""}
						label={t("Vessel")}
						autoComplete="off"
						onChange={(e) => {
							setFilter({ ...filter, vessel: e.value });
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter") applyFilter("vessel");
						}}
						onBlur={() => applyFilter("vessel")}
						style={{ width: "100%" }}
					/>
				</div>
			</div>
			<div className="filter-end-btn user-list-filter-end-btn">
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
